import React from "react";
import { Link } from "react-router-dom";
import brandConfig from "../config";
import "../css/faqs.scss";

const faqGroups = [
  {
    label: "Playing",
    items: [
      ["Can I try a game before choosing an edition?", "Yes. Every game listing includes a playable browser demo so you can understand its controls and core rules before making a decision."],
      ["Do I need to create an account?", "No. The current anackmira experience works without an account. Saved games, progress and demo unlocks remain in the browser you are using."],
      ["Which devices are supported?", "Use a current desktop or mobile browser with JavaScript enabled. Keyboard controls are available on desktop, and suitable games include touch controls."],
    ],
  },
  {
    label: "Orders & access",
    items: [
      ["Does the current checkout charge real money?", "No. Checkout is currently a demonstration. It does not process a card or create a real financial transaction."],
      ["How are digital editions delivered?", "A completed demonstration order unlocks the selected edition locally in the same browser. No physical product, download code or shipping email is sent."],
      ["Can I move an unlock to another device?", "Not in the current version. Local unlocks are tied to browser storage and do not sync across devices or browsers."],
      ["How do refunds work?", "Because the current checkout does not take payment, there is no real charge to refund. See the Refunds page for the policy that must be reviewed before commercial launch."],
    ],
  },
  {
    label: "Privacy & support",
    items: [
      ["What cookies or browser storage do you use?", "Essential local storage keeps your cart, favourites, progress, demo orders and consent preference on this device. anackmira does not currently use advertising cookies."],
      ["How can I clear my local data?", "Open the Privacy page and use the clear-data control. You can also remove site data through your browser settings."],
      ["Who operates anackmira?", `${brandConfig.legalName} operates the anackmira brand from ${brandConfig.address.replace(/\n/g, ", ")}.`],
      ["How can I contact you?", `Email ${brandConfig.email}. We recommend that you do not send payment-card, bank or other sensitive information.`],
    ],
  },
];

function Faqs() {
  return (
    <main className="faq-page page-shell">
      <header className="faq-hero">
        <p className="eyebrow">Help centre</p>
        <h1>Questions, answered clearly.</h1>
        <p>Quick guidance about playing, demonstration orders, browser storage and support.</p>
      </header>
      <div className="faq-layout">
        <aside>
          <span>Still need help?</span>
          <h2>Talk to our team.</h2>
          <p>Send your question to <a href={`mailto:${brandConfig.email}`}>{brandConfig.email}</a>.</p>
          <Link className="button button--quiet" to="/contact">Contact us</Link>
        </aside>
        <div className="faq-groups">
          {faqGroups.map((group) => (
            <section key={group.label}>
              <p className="eyebrow">{group.label}</p>
              {group.items.map(([question, answer]) => (
                <details key={question}>
                  <summary>{question}<span aria-hidden="true">+</span></summary>
                  <p>{answer}</p>
                </details>
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

export default Faqs;
